<template>
    <div class="header"></div>
</template>

<script>
export default {
    methods: {},
}
</script>

<style lang="less" scoped>
.header {
}
</style>
